export default "__VITE_ASSET__c2e68619__"